import { css, keyframes } from "@emotion/react";


const errorAnimation = keyframes`
    0% {
    opacity: 0.6;
    }
    50% {
    opacity: 1;
   
    transform:scale(1.15);
  
    }
    100% {
    opacity: 0.6;
    }
`;

export const notificationHolder = css`
    display: -webkit-box;
    margin: 40px 24px;
    padding: 24px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`

export const statusMessage = css`
    font-family: 'Manrope', sans-serif;
    width:100%;
    font-size: 12px;
    font-style: italic;
    font-weight: bold;

    &.error {
        color: #ff0000;
    }
    &.default {
    color:#636468
    }
    &.warning {
        color: #FFD700;
    }
`

export const warningIcon = css`
    font-size: 2.3rem;
    margin-left: auto;
    border-radius: 50%;
    padding: 0px;
    animation: ${errorAnimation} 2s cubic-bezier(.86,.07,.19,.97) both infinite;
    transform: translate3d(0, 0, 0);
    margin-right: 10px;
    
    &.error {
        color: #ff0000;    
    }
    
    &.warning {
        color: #FFD700;
    }
    
    &.expire {
        color: #FDDA0D;
    }
`;

export const link = css`
    font-size: 12px;
    margin-left:4px;
    color:#ff5100;
    cursor:pointer;
    font-weight: bold;
    text-decoration: underline;
`